import { Dialog, DialogContent, DialogTitle, DialogDescription } from '@talentmesh/ui/components/dialog';
import { cn } from '@talentmesh/ui/lib/utils';
import { ReactNode } from 'react';
import { DialogEnum, useActionDialogContext } from '../Context/ActionDialogContext';

interface ActionConfirmationDialogProps {
    dialogType: DialogEnum;
    header: ReactNode;
    body: ReactNode;
    actions: ReactNode;
    renderClose?: boolean;
    className?: string;
}

function ActionConfirmationDialog({
    dialogType,
    header,
    body,
    actions,
    renderClose = true,
    className,
}: ActionConfirmationDialogProps) {
    const { hideDialog, isDialogOpen } = useActionDialogContext();

    const closeConfirm = () => {
        hideDialog(dialogType);
    };

    return (
        <Dialog open={isDialogOpen(dialogType)} onOpenChange={(open) => !open && closeConfirm()}>
            <DialogContent
                showCloseButton={renderClose}
                className={cn('flex max-w-2xl flex-col gap-3.5 p-6 pt-0', className)}
            >
                <DialogTitle className="sr-only">Confirmation</DialogTitle>
                <DialogDescription className="sr-only">Confirmation dialog</DialogDescription>

                <div className="flex flex-row items-start justify-between">{header}</div>

                <div className="flex flex-row gap-2">{body}</div>
                <div className="flex flex-row gap-1">{actions}</div>
            </DialogContent>
        </Dialog>
    );
}

export default ActionConfirmationDialog;
